import React, { useEffect, useRef, useState, useLayoutEffect } from "react"

import { BackToTopIcon } from "components/page-components/Icons/small"
import { Footer } from "components/structure-components/footer"
import { Header } from "components/structure-components/header"
import { Submenu } from "components/structure-components/submenu"
import { useWindowDimensions } from "hooks"
import {
  ExitIntentSignupModal,
  NewsletterSignupFlag,
} from "components/page-components/Signup-Modules"
import scroll_top from "scripts/scrollTop"
import { AnnouncementFlag } from "components/page-components/Info-Modules"

const Layout = ({ children, location, breadcrumb_array, is_404 }) => {
  const [has_sticky_submenu, set_has_sticky_submenu] = useState(false)
  const { windowWidth } = useWindowDimensions()
  const possibilities = [
    "ausschreibungsdienste",
    "evergabe",
    "ueber-uns",
    "galabau",
    "umweltbau",
    "baumagazin",
    "academy",
    "vergabe-wissen",
  ]

  let page = ""
  if (location) {
    const path = location.pathname.split("/")
    page = possibilities.filter((element) => path.includes(element))[0]
    if (!page) {
      page =
        path[1] === "login"
          ? "login"
          : path.includes("fachzeitschriften")
            ? "fachzeitschriften"
            : "ueber-uns"
    }
  }

  const content_wrapper_ref = useRef(null)
  const handleScroll = () => {
    if (content_wrapper_ref.current) {
      set_has_sticky_submenu(
        content_wrapper_ref.current.getBoundingClientRect().top <= -60
      )
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const [exit_intent_modal_open, set_exit_intent_modal_open] = useState(false)
  const [page_load_time, set_page_load_time] = useState(9692088605762)

  const [decoded_cookie_array, set_decoded_cookie_array] = useState(null)

  const close_exit_intent_modal = () => {
    document.cookie = "exit_intent_cookie=pause;max-age=604800;path=/"
    set_decoded_cookie_array(decodeURIComponent(document?.cookie)?.split(";"))
    set_exit_intent_modal_open(false)
  }

  const [show_newsletter_flag, set_show_newsletter_flag] = useState(false)
  const close_newsletter_flag = (e) => {
    if (!!e && !!e?.preventDefault) {
      e.preventDefault()
    }
    if (show_newsletter_flag) {
      document.cookie = "newsletter_flag_cookie=pause;max-age=604800;path=/"
    }
    set_show_newsletter_flag(false)
  }

  const has_newsletter = [
    "baumagazin",
    "galabau",
    "umweltbau",
    "evergabe",
    "vergabe-wissen",
    "ausschreibungsdienste",
  ].includes(page)

  const has_newsletter_flag =
    /vergabe-wissen\/(blog|news|lexikon)\/[\w-]+|fachzeitschriften\/(galabau|baumagazin|umweltbau)\/[\w-]+\/[\w-]+(([a-z])\d{4,})/.test(
      location?.pathname
    )
  const has_announcement_flag = /support|login/.test(location?.pathname)

  const [show_announcement_flag, set_show_announcement_flag] = useState(false)
  const close_announcement_flag = (e) => {
    if (!!e && !!e?.preventDefault) {
      e.preventDefault()
    }
    if (show_announcement_flag) {
      document.cookie = "announcement_flag_cookie=pause;max-age=604800;path=/"
    }
    set_show_announcement_flag(false)
  }

  useLayoutEffect(() => {
    const now = Date.now()
    set_page_load_time(now)
    set_decoded_cookie_array(decodeURIComponent(document?.cookie)?.split(";"))
    setTimeout(() => {
      const newsletter_flag_cookie = decodeURIComponent(document?.cookie)
        ?.split(";")
        ?.filter((cookie) =>
          /newsletter_flag_cookie/.test(cookie.split("=")[0])
        )?.[0]
        ?.split("=")?.[1]
      if (has_newsletter_flag && newsletter_flag_cookie !== "pause") {
        set_show_newsletter_flag(true)
      }
    }, 7000)

    const announcement_flag_cookie = decodeURIComponent(document?.cookie)
      ?.split(";")
      ?.filter((cookie) =>
        /announcement_flag_cookie/.test(cookie.split("=")[0])
      )?.[0]
      ?.split("=")?.[1]
    const is_announcement_time = now > 1734908400000 && now < 1735682400000
    if (
      has_announcement_flag &&
      announcement_flag_cookie !== "pause" &&
      is_announcement_time
    ) {
      set_show_announcement_flag(true)
    }
  }, []) //eslint-disable-line

  const trigger_exit_intent_modal = () => {
    const exit_intent_cookie = decoded_cookie_array
      ?.filter((cookie) => /exit_intent_cookie/.test(cookie.split("=")[0]))?.[0]
      ?.split("=")?.[1]

    has_newsletter &&
      !is_404 &&
      !!decoded_cookie_array &&
      exit_intent_cookie !== "pause" &&
      Date.now() - page_load_time > 5000 &&
      set_exit_intent_modal_open(true)
  }

  return (
    <div className={`main-wrapper selection-${page}`}>
      {exit_intent_modal_open ? (
        <ExitIntentSignupModal
          {...{
            exit_intent_modal_open,
            close_exit_intent_modal,
            ressort:
              page === "ausschreibungsdienste" || page === "vergabe-wissen"
                ? "evergabe"
                : page,
          }}
        />
      ) : null}
      {has_newsletter_flag && !has_announcement_flag ? (
        <NewsletterSignupFlag
          {...{
            show_newsletter_flag,
            close_newsletter_flag,
            windowWidth,
            ressort:
              page === "ausschreibungsdienste" || page === "vergabe-wissen"
                ? "evergabe"
                : page,
          }}
        />
      ) : null}
      {has_announcement_flag ? (
        <AnnouncementFlag
          {...{
            announcement_title: "",
            announcement_text: "",
            show_flag: show_announcement_flag,
            close_flag: close_announcement_flag,
            severity: "warning",
            windowWidth,
            default_expanded: true,
          }}
        />
      ) : null}
      <div ref={content_wrapper_ref} className="content-wrapper">
        <a
          href=" #"
          onClick={scroll_top}
          title="Zurück nach oben"
          className={`${
            has_sticky_submenu ? "back-to-top has-text-centered" : "is-hidden"
          }`}
          aria-label="Zurück nach oben"
        >
          <BackToTopIcon />
        </a>

        <Header {...{ windowWidth, location }} />

        {!!location && page !== "login" ? (
          <Submenu {...{ page, has_sticky_submenu, windowWidth }} />
        ) : null}

        <div
          onMouseLeave={trigger_exit_intent_modal}
          role="button"
          tabIndex="-1"
          onKeyDown={() => {}}
          aria-label="Page Wrapper mouse listener"
          className={`page-content-wrapper`}
          style={{
            paddingTop:
              has_sticky_submenu && location && page !== "login" ? 80 : 0,
          }}
        >
          {children}
        </div>
      </div>
      <Footer
        {...{ page: page === "login" ? "ueber-uns" : page, breadcrumb_array }}
      />
    </div>
  )
}

export default Layout
